import React from "react"
import gql from "graphql-tag"
import PropTypes from "prop-types"

import {Query} from "../"

export const query = gql`
  query InsightsReporting($params: InsightsReportingParams!) {
    insightsReporting(params: $params) {
      timesSelected
      timesAnswered
      timesSkipped
      answersAverage
      answers {
        count
        value
      }
    }
  }`

export const defaultParams = {
  minOpenedAt: "",
  maxOpenedAt: "",
  driverId: "",
  surveyId: "",
  scheduleId: "",
  questionId: "",
  team: ""
}

const ReportingQuery = ({children, variables: {params: newParams}, ...props}) => {
  const params = {
    ...defaultParams,
    ...newParams
  }
  return (
    <Query
      {...props}
      variables={{params}}
      query={query}>
      {({data: {insightsReporting: stats = {}} = {}, historicalData: {insightsReporting: historicalStats = {}} = {}, ...apolloState}) => {
        return children({stats, historicalStats, ...apolloState})
      }}
    </Query>
  )
}

ReportingQuery.propTypes = {
  children: PropTypes.func.isRequired,
  variables: PropTypes.shape({
    params: PropTypes.object.isRequired
  }).isRequired
}


export default ReportingQuery
